import { render, staticRenderFns } from "./admin-dropped-2022.vue?vue&type=template&id=47245b41&scoped=true"
import script from "./admin-dropped-2022.vue?vue&type=script&lang=js"
export * from "./admin-dropped-2022.vue?vue&type=script&lang=js"
import style0 from "./admin-dropped-2022.vue?vue&type=style&index=0&id=47245b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47245b41",
  null
  
)

export default component.exports